import React, { Component } from "react";
import { withStyles } from '@material-ui/core/styles';
import { Link } from "routes";
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const styles = theme => ({ 
    categoryNameStyle: { 
        color: '#306ca0', 
        fontSize: 14, 
        overflowWrap: 'break-word', 
        fontWeight: 'bold',
        padding: '0 10px'
      }
})

class VideoDetailCategories extends Component {
  render() {
    const { classes, videoType, categoryNames } = this.props;
    const routeName = videoType == 'TV' ? 'categoryTv' : 'categoryVideos';
    return (
        categoryNames.length != 0 ?
            <Grid
                container
                direction="row" style={{ paddingTop: 14}}
                >
                    <Typography component="span" style={{color: '#95938d', paddingRight: 20}} >
                        Category
                    </Typography>
                    {
                    categoryNames.map((item, i) =>{
                        const isCategory = (item.type === 'VIDEO' || item.type === 'TV') && item.sub_categories;
                        return(
                            <Link key={i} 
                                route={ // check category and subcategory of video
                                    isCategory ? 
                                        item.type === 'VIDEO' ? 'videos' : 'tv' // check Video and TV section
                                    : routeName }   
                                params={isCategory ? '' : { id: item.slug }}
                            > 
                                <a className="anchor-link">
                                    <Typography component="span" className={classes.categoryNameStyle}>
                                        {item.name}
                                    </Typography>
                                </a>
                            </Link>
                            )
                        })
                    }
            </Grid>
        : null
    );
  }
}

export default withStyles(styles)(VideoDetailCategories);
